export default __webpack_public_path__ + "static/media/fatou_stroke.763d42bf.png";